"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _mixinPanel = _interopRequireDefault(require("@/libs/flowable/common/mixinPanel"));
var _listenerParam = _interopRequireDefault(require("./listenerParam"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    listenerParam: _listenerParam.default
  },
  mixins: [_mixinPanel.default],
  data: function data() {
    return {
      dialogVisible: true,
      showParamDialog: false,
      nowIndex: null,
      formData: {
        executionListener: []
      }
    };
  },
  computed: {
    formConfig: function formConfig() {
      //   const _this = this
      return {
        inline: false,
        item: [{
          xType: 'tabs',
          tabs: [{
            label: '执行监听器',
            name: 'executionListener',
            column: [{
              label: '事件',
              name: 'event',
              width: 180,
              rules: [{
                required: true,
                message: '请选择',
                trigger: ['blur', 'change']
              }],
              xType: 'select',
              dic: [{
                label: 'start',
                value: 'start'
              }, {
                label: 'end',
                value: 'end'
              }, {
                label: 'take',
                value: 'take'
              }]
            }, {
              label: '类型',
              name: 'type',
              width: 180,
              rules: [{
                required: true,
                message: '请选择',
                trigger: ['blur', 'change']
              }],
              xType: 'select',
              dic: [{
                label: '类',
                value: 'class'
              }, {
                label: '表达式',
                value: 'expression'
              }, {
                label: '委托表达式',
                value: 'delegateExpression'
              }],
              tooltip: "\u7C7B\uFF1A\u793A\u4F8B com.company.MyCustomListener\uFF0C\u81EA\u5B9A\u4E49\u7C7B\u5FC5\u987B\u5B9E\u73B0 org.flowable.engine.delegate.TaskListener \u63A5\u53E3 <br />\n                              \u8868\u8FBE\u5F0F\uFF1A\u793A\u4F8B ${myObject.callMethod(task, task.eventName)} <br />\n                              \u59D4\u6258\u8868\u8FBE\u5F0F\uFF1A\u793A\u4F8B ${myListenerSpringBean} \uFF0C\u8BE5 springBean \u9700\u8981\u5B9E\u73B0 org.flowable.engine.delegate.TaskListener \u63A5\u53E3\n                    "
            }, {
              label: 'java 类名',
              name: 'className',
              xType: 'input',
              rules: [{
                required: true,
                message: '请输入',
                trigger: ['blur', 'change']
              }]
            }, {
              xType: 'slot',
              label: '参数',
              width: 120,
              slot: true,
              name: 'params'
            }]
          }]
        }]
      };
    }
  },
  mounted: function mounted() {
    var obj2 = this.element.businessObject.extensionElements.values.filter(function (item) {
      return item.$type === 'flowable:ExecutionListener';
    }).map(function (item) {
      var type;
      if ('class' in item) type = 'class';
      if ('expression' in item) type = 'expression';
      if ('delegateExpression' in item) type = 'delegateExpression';
      var obj = item.fields.map(function (field) {
        var fieldType;
        if ('stringValue' in field) fieldType = 'stringValue';
        if ('expression' in field) fieldType = 'expression';
        return {
          name: field.name,
          type: fieldType,
          value: field[fieldType]
        };
      });
      return {
        event: item.event,
        type: type,
        className: item[type],
        params: obj != null ? obj : []
      };
    });
    this.formData.executionListener = obj2 != null ? obj2 : [];
  },
  methods: {
    configParam: function configParam(index) {
      this.nowIndex = index;
      var nowObj = this.formData.executionListener[index];
      if (!nowObj.params) {
        nowObj.params = [];
      }
      this.showParamDialog = true;
    },
    finishConfigParam: function finishConfigParam(param) {
      this.showParamDialog = false;
      // hack 数量不更新问题
      var cache = this.formData.executionListener[this.nowIndex];
      cache.params = param;
      this.$set(this.formData.executionListener[this.nowIndex], this.nowIndex, cache);
      this.nowIndex = null;
    },
    updateElement: function updateElement() {
      var _this = this;
      if (this.formData.executionListener.length) {
        var extensionElements = this.element.businessObject.get('extensionElements');
        if (!extensionElements) {
          extensionElements = this.modeler.get('moddle').create('bpmn:ExtensionElements');
        }
        // 清除旧值
        var obj = extensionElements.values.filter(function (item) {
          return item.$type !== 'flowable:ExecutionListener';
        });
        extensionElements.values = obj != null ? obj : [];
        this.formData.executionListener.forEach(function (item) {
          var executionListener = _this.modeler.get('moddle').create('flowable:ExecutionListener');
          executionListener['event'] = item.event;
          executionListener[item.type] = item.className;
          if (item.params && item.params.length) {
            item.params.forEach(function (field) {
              var fieldElement = _this.modeler.get('moddle').create('flowable:Field');
              fieldElement['name'] = field.name;
              fieldElement[field.type] = field.value;
              // 注意：flowable.json 中定义的string和expression类为小写，不然会和原生的String类冲突，此处为hack
              // const valueElement = this.modeler.get('moddle').create(`flowable:${field.type}`, { body: field.value })
              // fieldElement[field.type] = valueElement
              executionListener.get('fields').push(fieldElement);
            });
          }
          extensionElements.get('values').push(executionListener);
        });
        this.updateProperties({
          extensionElements: extensionElements
        });
      } else {
        var _extensionElements = this.element.businessObject["extensionElements"];
        if (_extensionElements) {
          var _obj = _extensionElements.values.filter(function (item) {
            return item.$type !== 'flowable:ExecutionListener';
          });
          _extensionElements.values = _obj != null ? _obj : [];
        }
      }
    },
    closeDialog: function closeDialog() {
      var _this2 = this;
      this.$refs.xForm.validate().then(function () {
        _this2.updateElement();
        _this2.dialogVisible = false;
      }).catch(function (e) {
        return console.error(e);
      });
    }
  }
};